import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { Container, Card } from "react-bootstrap";
import toast, { Toaster } from 'react-hot-toast';

import Spinner from "../../../components/Common/Spinner";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import './user-account-setting.css';
import Header from "../../../components/partials/dashboard/HeaderStyle/header";
import { getToken } from "../../../utils/auth";

const FAQ = () => {
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
const [faqs, setFaqs] = useState([]);

  const fetchFAQ= async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/faq/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("FAQ details fetched", response.data.data.faqsData);
      setFaqs(response.data.data.faqsData);
    } catch (error) {
      console.error("Failed Fetching FAQ Details", error);
    }
  };

 useEffect(() => {
  fetchFAQ();
 },[]);

  return (
    <>
      {/* {loading ? (
        <Spinner />
      ) : ( */}
        <Container style={{ marginTop: "2%" }}>
          <div style={{ display: "none" }}>
            <Header/>
          </div>
          {faqs.map((faq, index) => (
            <div className="accordion" key={index} style={{ marginBlock: "5px" }}>
              <div
                className="accordion-item"
                style={{ borderBottom: "1px solid #d4d4d4" }}
              >
                <div
                  className="accordion-title"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    paddingInline: "20px",
                  }}
                  onClick={() => toggleSection(index)}
                >
                  <div
                    style={{
                      display: "flex",
                      fontSize: "20px",
                      paddingBlock: "5px",
                    }}
                  >
                    {faq.question}
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {activeIndex === index ? (
                      <MdKeyboardArrowUp size={30} />
                    ) : (
                      <MdKeyboardArrowDown size={30} />
                    )}
                  </div>
                </div>
                {activeIndex === index && (
                  <div className="accordion-content">
                    <Card>
                      <Card.Body>
                        <div className="acc-edit">
                          {faq.answer}
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                )}
              </div>
            </div>
          ))}
        </Container>
      {/* )} */}
      <Toaster position="top-right" reverseOrder={false}/>
      </>
  );
};

export default FAQ;
